import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import {
	AssignmentHistoryLayerActions,
	getAssignmentHistoryLayerList,
} from './assignment-history-layer';
import {
	AuthActions,
	deviceLogin,
	login,
	logout,
	oauthLogin,
	verifyOtp,
} from './auth';
import {
	CommonActions,
	commonFileUpload,
	createCommonAssignment,
	createCommonPublicAssignment,
	getAppUserInfoSaga,
	getAutocompleteSuggestion,
	getCommonApplicantAssignmentListSaga,
	getCommonApplicantListSaga,
	getCommonApplicantWithIdsSaga,
	getCommonDocumentObjectDetail,
	getCommonDocumentObjectList,
	getDocumentJsonContentSaga,
	getDocumentMappingsSaga,
	getFieldsSaga,
	getListCommonSaga,
	getSettingColumnSaga,
	getUpdateHistoryListSaga,
	getYearRegisterListSaga,
	resetPasswordCommonSaga,
	setSettingColumnSaga,
	unWithdrawnCommonSaga,
	updateCommonRecommenderSaga,
	updateFields,
	uploadFile,
	verifyDomain,
	verifyEmail,
} from './common';
import {
	CommonInquiryBoardActions,
	createCommonInquiryBoard,
	deleteCommonInquiryBoard,
	getCommonInquiryBoardDetail,
	getCommonInquiryBoardDetailAnswer,
	getCommonInquiryBoardList,
} from './common-inquiry-board';
import {
	CommonInquiryBoardAnswerActions,
	deleteAnswerCommonInquiryBoard,
	deleteCommonInquiryBoardAnswer,
	getCommonInquiryBoardAnswerDetail,
	getCommonInquiryBoardAnswerDetailAnswer,
	getCommonInquiryBoardAnswerList,
	saveAnswerCommonInquiryBoard,
} from './common-inquiry-board-answer';
import {
	CommonNoticeActions,
	createCommonNotice,
	deleteCommonNotices,
	getCommonNoticeDetail,
	getCommonNoticeList,
} from './common-notice';
import {
	CommonNoticeReceiveActions,
	deleteCommonNoticeReceives,
	getCommonNoticeReceiveDetail,
	getCommonNoticeReceiveList,
} from './common-notice-receive';
import {
	addContractedForeignBusiness,
	ContractedForeignBusinessActions,
	deleteContractedForeignBusiness,
	getContractedForeignBusiness,
} from './contracted-foreign-business';
import {
	DefineDocumentAreaActions,
	deleteDocuments,
	downloadDocument,
	getDefineDocumentAreaListByPage,
	updateDocumentItem,
	uploadDocument,
} from './define-document-area';
import {
	DefineDocumentDownloadActions,
	downloadDefineDocument,
	downloadDefineDocumentByIds,
	getDefineDocumentDownloadList,
} from './define-document-download';
import {
	DefineDocumentUploadActions,
	getDefineDocumentUploadListByPage,
	updateDocumentUpload,
} from './define-document-upload';
import { DeviceLogActions, getDeviceLogListSaga } from './device-log';
import {
	approveMobileDeviceSaga,
	DeviceMobileActions,
	getDeviceMobileDetailSaga,
	getDeviceMobileListSaga,
	reapproveMobileDeviceSaga,
	rejectMobileDeviceSaga,
	revokeMobileDeviceSaga,
} from './device-mobile';
import {
	DeviceTabletActions,
	getDeviceTabletListSaga,
	verifyTabletRegisterCodeSaga,
	verifyTabletRemoteCodeSaga,
} from './device-tablet';
import {
	createDistrictAllowIp,
	deleteDistrictAllowIp,
	DistrictAllowIpActions,
	getDistrictAllowIpList,
	updateDistrictAllowIp,
} from './district-allow-ip';
import {
	Fm1_01DefaultInfoUnitActions,
	getDefaultInfoUnitDetail,
} from './fm1-01-default-info-unit';
import {
	createFooterInfo,
	deleteFooterInfo,
	FooterInfoActions,
	getFooterInfoList,
} from './footer-info';
import {
	createForeignApplicants,
	deleteForeignApplicants,
	ForeignApplicantActions,
	getForeignApplicantDetail,
	getForeignApplicantList,
	getForeignApplicantProgramListSaga,
	resetPasswordSaga,
} from './foreign-applicant';
import {
	ForeignDashboardActions,
	getContractedKoreanBusiness,
	getForeignDashboardStatistic,
} from './foreign-dashboard';
import {
	getForeignDefaultInfoUnitDetail,
	getForeignDomesticUnitList,
	OI1_01DefaultInfoUnitActions,
} from './foreign-default-info-unit';
import {
	ForeignProgramActions,
	getForeignProgramApplicantList,
	getForeignProgramDetail,
	getForeignProgramList,
} from './foreign-program';
import {
	createForeignSystemUnit,
	deleteForeignSystemUnit,
	ForeignSystemUnitActions,
	getContractedKoreanBusinessSystem,
	getForeignSystemUnitDetail,
	getForeignSystemUnitList,
} from './foreign-system-unit';
import {
	createForeignUsers,
	deleteForeignUsers,
	ForeignUserActions,
	getForeignUserDetail,
	getForeignUserList,
} from './foreign-user';
import {
	getMSelectLodgingPopupList,
	MSelectLodgingPopupActions,
} from './m-select-lodging-popup';
import { getDataMyPage, MyPageActions, updateDataMyPageSaga } from './my-page';
import {
	AssignmentCalendarActions,
	getApplicantAssignmentAutocomplete,
	getEnablePublicApplicants,
	getFranchiseAssignmentAutocomplete,
	getPublicAssignment,
	getPublicListWithDateSaga,
} from './pa2-01-assignment-calendar';
import {
	getPublicWorkHistoryLayerList,
	PublicWorkHistoryLayerActions,
} from './public-work-history-layer';
import {
	createSystemUnit,
	deleteSystemUnit,
	getSystemHistoryUpdateSystemUnitList,
	getSystemUnitDetail,
	getSystemUnitList,
	SystemUnitActions,
} from './system-unit';
import {
	createSystemUseTip,
	deleteSystemUseTip,
	getSystemUseTipDetail,
	getSystemUseTipList,
	SystemUseTipActions,
} from './system-use-tip';
import {
	createSystemUsers,
	deleteSystemUsers,
	getSystemUserDetail,
	getSystemUserList,
	SystemUserActions,
} from './system-user';
import {
	deleteUnitSettingMasterInfo,
	getUnitSettingMasterInfo,
	UnitSettingActions,
	updateUnitSettingMasterInfo,
} from './us1-01-unit-setting';
import {
	getWorkHistoryLayerList,
	WorkHistoryLayerActions,
} from './work-history-layer';
import {
	canAssignApplicantSaga,
	createWorkerApplicantLodgingSaga,
	createWorkerApplicantProgramSaga,
	createWorkerApplicantSaga,
	deleteWorkerApplicantLodgingSaga,
	deleteWorkerApplicantProcessInfosSaga,
	deleteWorkerApplicantsAssignmentSaga,
	deleteWorkerApplicantsProgramSaga,
	deleteWorkerApplicantsSaga,
	getApplicantNameplateSaga,
	getWorkerApplicantAssignmentListSaga,
	getWorkerApplicantDepartureDateSaga,
	getWorkerApplicantDetailSaga,
	getWorkerApplicantExcelListSaga,
	getWorkerApplicantListSaga,
	getWorkerApplicantLodgingAutoFillSaga,
	getWorkerApplicantLodgingSaga,
	getWorkerApplicantProcessInfoListSaga,
	getWorkerApplicantProgramListSaga,
	getWorkerApplicantRecommenderSaga,
	updateExtensionPeriodSaga,
	updateStatusWorkerApplicantSaga,
	updateWorkerApplicantRecommenderSaga,
	uploadExcelApplicantSaga,
	WorkerApplicantActions,
} from './worker-applicant';
import {
	deleteWorkerAssignments,
	getWorkerAssignmentApplicantListSaga,
	getWorkerAssignmentDetail,
	getWorkerAssignmentEvaluationSaga,
	getWorkerAssignmentExcelListSaga,
	getWorkerAssignmentListSaga,
	updateWorkerAssignmentApplicantStatusSaga,
	uploadExcelAssignmentSaga,
	uploadExcelPublicAssignmentSaga,
	WorkerAssignmentActions,
} from './worker-assignment';
import {
	deleteWorkerAssignmentFranchiseSaga,
	getWorkerAssignmentFranchiseExcelListSaga,
	getWorkerAssignmentFranchiseListSaga,
	WorkerAssignmentFranchiseActions,
} from './worker-assignment-franchise';
import {
	deleteWorkerAssignmentPublicSaga,
	getWorkerAssignmentPublicApplicantListSaga,
	getWorkerAssignmentPublicDetailSaga,
	getWorkerAssignmentPublicExcelListSaga,
	getWorkerAssignmentPublicListSaga,
	WorkerAssignmentPublicActions,
} from './worker-assignment-public';
import {
	getWorkerAuditMonitoringListSaga,
	WorkerAuditMonitoringActions,
} from './worker-audit-monitoring';
import {
	createWorkerChangeWorkPlace,
	deleteWorkerChangeWorkPlace,
	getWorkerChangeWorkPlaceDetail,
	getWorkerChangeWorkPlaceExcelListSaga,
	getWorkerChangeWorkPlaceListSaga,
	WorkerChangeWorkPlaceActions,
} from './worker-change-work-place';
import {
	getWorkerDashboardInquiryList,
	getWorkerDashboardNoticeList,
	getWorkerDashboardNoticeReceiveList,
	getWorkerDashboardStatistic,
	getWorkerDashboardStatisticApplicant,
	getWorkerDashboardStatisticFranchise,
	getWorkerDashboardUseTipList,
	WorkerDashboardActions,
} from './worker-dashboard';
import {
	deleteWorkerDocument,
	getWorkerDocumentDetail,
	getWorkerDocumentList,
	updateWorkerDocument,
	WorkerDocumentActions,
} from './worker-document';
import {
	createApplicantForExtensionStay,
	createWorkerExtensionStay,
	deleteApplicantExtensionStay,
	deleteExtensionStay,
	deleteWorkerExtensionStay,
	getApplicantByFranchiseExtensionStay,
	getApplicantForExtensionStayList,
	getApplicantListByIds,
	getWorkerExtensionStayDetail,
	getWorkerExtensionStayExcelListSaga,
	getWorkerExtensionStayListSaga,
	updateFranchiseWorkerExtensionStay,
	WorkerExtensionStayActions,
} from './worker-extension-stay';
import {
	approveWorkerFranchiseProgram,
	createWorkerFranchise,
	createWorkerFranchiseLodging,
	createWorkerFranchiseProgram,
	deleteWorkerFranchise,
	deleteWorkerFranchiseAssignmentList,
	deleteWorkerFranchiseLodgingList,
	deleteWorkerFranchiseProgramList,
	deleteWorkerFranchiseRecommenderSaga,
	getWorkerFranchiseAssignmentList,
	getWorkerFranchiseDetail,
	getWorkerFranchiseExcelListSaga,
	getWorkerFranchiseListSaga,
	getWorkerFranchiseLodgingList,
	getWorkerFranchiseProgramList,
	getWorkerFranchiseRecommenderSaga,
	rejectWorkerFranchiseProgram,
	uploadExcelWorkerFranchise,
	WorkerFranchiseActions,
} from './worker-franchise';
import { getWorkerHistoryList, WorkerHistoryActions } from './worker-history';
import {
	createLodging,
	createLodgingApplicant,
	deleteApplicantListByLodgingId,
	deleteWorkerLodgingById,
	deleteWorkerLodgings,
	getApplicantListByLodgingId,
	getProviderInfoList,
	getWorkerLodgingApplicantListSaga,
	getWorkerLodgingDetail,
	getWorkerLodgingExcelListSaga,
	getWorkerLodgingListSaga,
	updateLodgingProviderSaga,
	uploadExcelLodgingSaga,
	WorkerLodgingActions,
} from './worker-lodging';
import {
	createWorkerProgramApplicant,
	createWorkerProgramFranchises,
	createWorkerPrograms,
	deleteWorkerProgram,
	deleteWorkerProgramApplicantList,
	deleteWorkerProgramFranchiseList,
	getWorkerProgramAllList,
	getWorkerProgramApplicantList,
	getWorkerProgramApplicantStatus,
	getWorkerProgramDetail,
	getWorkerProgramExcelListSaga,
	getWorkerProgramFranchiseList,
	getWorkerProgramFranchiseStatus,
	getWorkerProgramListSaga,
	WorkerProgramActions,
} from './worker-program';
import {
	deleteWorkerProgramStatus,
	getWorkerProgramStatusExcelList,
	getWorkerProgramStatusList,
	WorkerProgramStatusActions,
} from './worker-program-status';
import {
	getPublicSalaryApplicantListSaga,
	getPublicSalaryDetailSaga,
	getPublicSalaryExcelListSaga,
	getPublicSalaryListSaga,
	WorkerPublicSalaryActions,
} from './worker-public-salary';
import {
	createWorkerRecommenderApplicantSaga,
	createWorkerRecommenderSaga,
	deleteWorkerRecommenderApplicantSaga,
	deleteWorkerRecommenderLodgingSaga,
	deleteWorkerRecommenders,
	getAllWorkerRecommenderApplicantListSaga,
	getWorkerRecommenderApplicantListSaga,
	getWorkerRecommenderDetail,
	getWorkerRecommenderExcelListSaga,
	getWorkerRecommenderListSaga,
	getWorkerRecommenderLodgingListSaga,
	uploadExcelRecommenderSaga,
	WorkerRecommenderActions,
} from './worker-recommender';
import {
	deleteWorkerSalary,
	getWorkerSalaryExcelListSaga,
	getWorkerSalaryListSaga,
	updateWorkerSalary,
	WorkerSalaryActions,
} from './worker-salary';
import {
	createWorkerUnauthorizedDeparture,
	deleteWorkerUnauthorizedDeparture,
	getWorkerUnauthorizedDepartureDetail,
	getWorkerUnauthorizedDepartureExcelListSaga,
	getWorkerUnauthorizedDepartureListSaga,
	WorkerUnauthorizedDepartureActions,
} from './worker-unauthorized-departure';
import {
	getWorkerUseTipDetail,
	getWorkerUseTipList,
	WorkerUseTipActions,
} from './worker-use-tip';
import {
	createWorkerUsers,
	deleteWorkerUsers,
	getWorkerUserDetail,
	getWorkerUserList,
	WorkerUserActions,
} from './worker-user';

/* ------------- Connect Types To Sagas ------------- */
export default function* rootSaga() {
	yield all([
		// MY PAGE
		takeLatest(MyPageActions.getDataMyPageRequest.type, getDataMyPage),
		takeLatest(
			MyPageActions.updateDataMyPageRequest.type,
			updateDataMyPageSaga
		),

		// COMMON
		takeLatest(CommonActions.verifyEmailRequest.type, verifyEmail),
		takeLatest(CommonActions.verifyDomainRequest.type, verifyDomain),
		takeEvery(CommonActions.getListCommonRequest.type, getListCommonSaga),
		takeEvery(CommonActions.uploadFileRequest.type, uploadFile),
		takeEvery(CommonActions.commonFileUploadRequest.type, commonFileUpload),
		takeEvery(CommonActions.updateFieldsRequest.type, updateFields),
		takeEvery(
			CommonActions.getYearRegisterListRequest.type,
			getYearRegisterListSaga
		),
		takeLatest(
			CommonActions.getDocumentObjectListRequest.type,
			getCommonDocumentObjectList
		),
		takeLatest(
			DefineDocumentAreaActions.getDefineDocumentAreaListRequest.type,
			getDefineDocumentAreaListByPage
		),
		takeLatest(
			DefineDocumentAreaActions.updateDocumentItemRequest.type,
			updateDocumentItem
		),
		takeLatest(
			DefineDocumentAreaActions.deleteDocumentsRequest.type,
			deleteDocuments
		),
		takeEvery(
			DefineDocumentAreaActions.downloadDocumentsRequest.type,
			downloadDocument
		),
		takeLatest(
			DefineDocumentAreaActions.uploadDocumentsRequest.type,
			uploadDocument
		),
		takeLatest(
			CommonActions.getSettingColumnRequest.type,
			getSettingColumnSaga
		),
		takeLatest(
			CommonActions.setSettingColumnRequest.type,
			setSettingColumnSaga
		),
		takeLatest(
			CommonActions.getUpdateHistoryListRequest.type,
			getUpdateHistoryListSaga
		),
		takeLatest(
			CommonActions.getAutocompleteSuggestionRequest.type,
			getAutocompleteSuggestion
		),
		takeLatest(
			CommonActions.getDocumentObjectDetailRequest.type,
			getCommonDocumentObjectDetail
		),
		takeLatest(
			AssignmentHistoryLayerActions.getAssignmentHistoryLayerListRequest.type,
			getAssignmentHistoryLayerList
		),

		takeLatest(
			CommonActions.getCommonApplicantListRequest.type,
			getCommonApplicantListSaga
		),

		takeLatest(
			CommonActions.createCommonAssignmentRequest.type,
			createCommonAssignment
		),

		takeLatest(
			CommonActions.createCommonPublicAssignmentRequest.type,
			createCommonPublicAssignment
		),

		takeLatest(
			CommonActions.getCommonApplicantAssignmentListRequest.type,
			getCommonApplicantAssignmentListSaga
		),

		takeLatest(
			CommonActions.getCommonApplicantWithIdsRequest.type,
			getCommonApplicantWithIdsSaga
		),

		takeLatest(
			CommonActions.updateCommonRecommenderRequest.type,
			updateCommonRecommenderSaga
		),

		takeLatest(CommonActions.getFieldsRequest.type, getFieldsSaga),

		takeLatest(
			CommonActions.resetPasswordRequest.type,
			resetPasswordCommonSaga
		),

		takeLatest(CommonActions.unWithdrawnRequest.type, unWithdrawnCommonSaga),

		takeLatest(CommonActions.getAppUserInfoRequest.type, getAppUserInfoSaga),

		takeLatest(
			CommonActions.getDocumentMappingsRequest.type,
			getDocumentMappingsSaga
		),

		// COMMON NOTICE
		takeLatest(
			CommonNoticeActions.getCommonNoticeListRequest.type,
			getCommonNoticeList
		),
		takeLatest(
			CommonNoticeActions.createCommonNoticeRequest.type,
			createCommonNotice
		),
		takeLatest(
			CommonNoticeActions.deleteCommonNoticeRequest.type,
			deleteCommonNotices
		),
		takeLatest(
			CommonNoticeActions.getCommonNoticeDetailRequest.type,
			getCommonNoticeDetail
		),

		// COMMON NOTICE RECEIVE
		takeLatest(
			CommonNoticeReceiveActions.getCommonNoticeReceiveListRequest.type,
			getCommonNoticeReceiveList
		),
		takeLatest(
			CommonNoticeReceiveActions.deleteCommonNoticeReceiveRequest.type,
			deleteCommonNoticeReceives
		),
		takeLatest(
			CommonNoticeReceiveActions.getCommonNoticeReceiveDetailRequest.type,
			getCommonNoticeReceiveDetail
		),

		// COMMON INQUIRY BOARD
		takeLatest(
			CommonInquiryBoardActions.getCommonInquiryBoardListRequest.type,
			getCommonInquiryBoardList
		),
		takeLatest(
			CommonInquiryBoardActions.createCommonInquiryBoardRequest.type,
			createCommonInquiryBoard
		),
		takeLatest(
			CommonInquiryBoardActions.deleteCommonInquiryBoardRequest.type,
			deleteCommonInquiryBoard
		),
		takeLatest(
			CommonInquiryBoardActions.getCommonInquiryBoardDetailRequest.type,
			getCommonInquiryBoardDetail
		),
		takeLatest(
			CommonInquiryBoardActions.getCommonInquiryBoardDetailAnswerRequest.type,
			getCommonInquiryBoardDetailAnswer
		),

		// COMMON INQUIRY BOARD ANSWER
		takeLatest(
			CommonInquiryBoardAnswerActions.getCommonInquiryBoardAnswerListRequest
				.type,
			getCommonInquiryBoardAnswerList
		),
		takeLatest(
			CommonInquiryBoardAnswerActions.getCommonInquiryBoardAnswerDetailRequest
				.type,
			getCommonInquiryBoardAnswerDetail
		),
		takeLatest(
			CommonInquiryBoardAnswerActions
				.getCommonInquiryBoardAnswerDetailAnswerRequest.type,
			getCommonInquiryBoardAnswerDetailAnswer
		),
		takeLatest(
			CommonInquiryBoardAnswerActions.deleteCommonInquiryBoardAnswerRequest
				.type,
			deleteCommonInquiryBoardAnswer
		),
		takeLatest(
			CommonInquiryBoardAnswerActions.saveAnswerCommonInquiryBoardAnswerRequest
				.type,
			saveAnswerCommonInquiryBoard
		),
		takeLatest(
			CommonInquiryBoardAnswerActions
				.deleteAnswerCommonInquiryBoardAnswerRequest.type,
			deleteAnswerCommonInquiryBoard
		),

		// DEFINE DOCUMENT DOWNLOAD
		takeLatest(
			DefineDocumentDownloadActions.getDefineDocumentDownloadListRequest.type,
			getDefineDocumentDownloadList
		),
		takeLatest(
			DefineDocumentDownloadActions.downloadDefineDocumentsRequest.type,
			downloadDefineDocument
		),
		takeLatest(
			DefineDocumentDownloadActions.downloadDefineDocumentByIdsRequest.type,
			downloadDefineDocumentByIds
		),

		// AUTHENTICATION
		takeLatest(AuthActions.loginRequest.type, login),
		takeLatest(AuthActions.oauthLoginRequest.type, oauthLogin),
		takeLatest(AuthActions.verifyOtpRequest.type, verifyOtp),
		takeLatest(AuthActions.deviceLoginRequest.type, deviceLogin),
		takeLatest(AuthActions.logoutRequest.type, logout),

		// SYSTEM USER
		takeLatest(
			SystemUserActions.getSystemUserListRequest.type,
			getSystemUserList
		),
		takeLatest(
			SystemUserActions.createSystemUserRequest.type,
			createSystemUsers
		),
		takeLatest(
			SystemUserActions.getSystemUserDetailRequest.type,
			getSystemUserDetail
		),
		takeLatest(
			SystemUserActions.deleteSystemUserRequest.type,
			deleteSystemUsers
		),

		// SYSTEM UNIT
		takeLatest(
			SystemUnitActions.getSystemUnitListRequest.type,
			getSystemUnitList
		),
		takeLatest(
			SystemUnitActions.deleteSystemUnitRequest.type,
			deleteSystemUnit
		),
		takeLatest(
			SystemUnitActions.createSystemUnitRequest.type,
			createSystemUnit
		),
		takeLatest(
			SystemUnitActions.getSystemUnitDetailRequest.type,
			getSystemUnitDetail
		),
		takeLatest(
			SystemUnitActions.getSystemHistoryUpdateSystemUnitListRequest.type,
			getSystemHistoryUpdateSystemUnitList
		),
		// SYSTEM ROLE

		// WORKER USER
		takeLatest(
			WorkerUserActions.getWorkerUserListRequest.type,
			getWorkerUserList
		),
		takeLatest(
			WorkerUserActions.createWorkerUserRequest.type,
			createWorkerUsers
		),
		takeLatest(
			WorkerUserActions.getWorkerUserDetailRequest.type,
			getWorkerUserDetail
		),
		takeLatest(
			WorkerUserActions.deleteWorkerUserRequest.type,
			deleteWorkerUsers
		),

		// WORKER APPLICANT
		takeLatest(
			WorkerApplicantActions.updateStatusWorkerApplicantRequest.type,
			updateStatusWorkerApplicantSaga
		),
		takeLatest(
			WorkerApplicantActions.updateExtensionPeriodRequest.type,
			updateExtensionPeriodSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantListRequest.type,
			getWorkerApplicantListSaga
		),
		takeLatest(
			WorkerApplicantActions.getApplicantNameplateRequest.type,
			getApplicantNameplateSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantExcelListRequest.type,
			getWorkerApplicantExcelListSaga
		),
		takeLatest(
			WorkerApplicantActions.createWorkerApplicantRequest.type,
			createWorkerApplicantSaga
		),
		takeLatest(
			WorkerApplicantActions.deleteWorkerApplicantRequest.type,
			deleteWorkerApplicantsSaga
		),
		takeLatest(
			WorkerApplicantActions.deleteWorkerApplicantAssignmentRequest.type,
			deleteWorkerApplicantsAssignmentSaga
		),
		takeLatest(
			WorkerApplicantActions.deleteWorkerApplicantProgramRequest.type,
			deleteWorkerApplicantsProgramSaga
		),
		takeLatest(
			WorkerApplicantActions.deleteWorkerApplicantLodgingRequest.type,
			deleteWorkerApplicantLodgingSaga
		),
		takeLatest(
			WorkerApplicantActions.createWorkerApplicantProgramRequest.type,
			createWorkerApplicantProgramSaga
		),
		takeLatest(
			WorkerApplicantActions.createWorkerApplicantLodgingRequest.type,
			createWorkerApplicantLodgingSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantDetailRequest.type,
			getWorkerApplicantDetailSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantAssignmentListRequest.type,
			getWorkerApplicantAssignmentListSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantRecommenderRequest.type,
			getWorkerApplicantRecommenderSaga
		),
		takeLatest(
			WorkerApplicantActions.updateWorkerApplicantRecommenderRequest.type,
			updateWorkerApplicantRecommenderSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantLodgingRequest.type,
			getWorkerApplicantLodgingSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantLodgingAutoFillRequest.type,
			getWorkerApplicantLodgingAutoFillSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantProgramListRequest.type,
			getWorkerApplicantProgramListSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantProcessInfoListRequest.type,
			getWorkerApplicantProcessInfoListSaga
		),
		takeLatest(
			WorkerApplicantActions.deleteWorkerApplicantProcessInfoRequest.type,
			deleteWorkerApplicantProcessInfosSaga
		),
		takeLatest(
			WorkerApplicantActions.uploadExcelApplicantRequest.type,
			uploadExcelApplicantSaga
		),
		takeLatest(
			WorkerApplicantActions.canAssignApplicantRequest.type,
			canAssignApplicantSaga
		),
		takeLatest(
			WorkerApplicantActions.getWorkerApplicantDepartureDateRequest.type,
			getWorkerApplicantDepartureDateSaga
		),

		// WORKER FRANCHISE
		takeLatest(
			WorkerFranchiseActions.getWorkerFranchiseListRequest.type,
			getWorkerFranchiseListSaga
		),
		takeLatest(
			WorkerFranchiseActions.getWorkerFranchiseExcelListRequest.type,
			getWorkerFranchiseExcelListSaga
		),
		takeLatest(
			WorkerFranchiseActions.createWorkerFranchiseRequest.type,
			createWorkerFranchise
		),
		takeLatest(
			WorkerFranchiseActions.getWorkerFranchiseDetailRequest.type,
			getWorkerFranchiseDetail
		),
		takeLatest(
			WorkerFranchiseActions.deleteWorkerFranchiseRequest.type,
			deleteWorkerFranchise
		),
		takeLatest(
			WorkerFranchiseActions.getWorkerFranchiseAssignmentListRequest.type,
			getWorkerFranchiseAssignmentList
		),
		takeLatest(
			WorkerFranchiseActions.deleteWorkerFranchiseAssignmentRequest.type,
			deleteWorkerFranchiseAssignmentList
		),
		takeLatest(
			WorkerFranchiseActions.getWorkerFranchiseLodgingListRequest.type,
			getWorkerFranchiseLodgingList
		),
		takeLatest(
			WorkerFranchiseActions.deleteWorkerFranchiseLodgingRequest.type,
			deleteWorkerFranchiseLodgingList
		),
		takeLatest(
			WorkerFranchiseActions.createWorkerFranchiseLodgingRequest.type,
			createWorkerFranchiseLodging
		),
		takeLatest(
			WorkerFranchiseActions.getWorkerFranchiseProgramListRequest.type,
			getWorkerFranchiseProgramList
		),
		takeLatest(
			WorkerFranchiseActions.deleteWorkerFranchiseProgramRequest.type,
			deleteWorkerFranchiseProgramList
		),
		takeLatest(
			WorkerFranchiseActions.createWorkerFranchiseProgramRequest.type,
			createWorkerFranchiseProgram
		),
		takeLatest(
			WorkerFranchiseActions.uploadExcelWorkerFranchiseRequest.type,
			uploadExcelWorkerFranchise
		),
		takeLatest(
			WorkerFranchiseActions.getWorkerFranchiseRecommenderInfoRequest.type,
			getWorkerFranchiseRecommenderSaga
		),
		takeLatest(
			WorkerFranchiseActions.deleteWorkerFranchiseRecommenderRequest.type,
			deleteWorkerFranchiseRecommenderSaga
		),
		takeLatest(
			WorkerFranchiseActions.approveWorkerFranchiseProgramRequest.type,
			approveWorkerFranchiseProgram
		),
		takeLatest(
			WorkerFranchiseActions.rejectWorkerFranchiseProgramRequest.type,
			rejectWorkerFranchiseProgram
		),

		// WORKER LODGING
		takeLatest(
			WorkerLodgingActions.getWorkerLodgingListRequest.type,
			getWorkerLodgingListSaga
		),
		takeLatest(
			WorkerLodgingActions.getWorkerLodgingExcelListRequest.type,
			getWorkerLodgingExcelListSaga
		),
		takeLatest(
			WorkerLodgingActions.getWorkerLodgingDetailRequest.type,
			getWorkerLodgingDetail
		),

		takeLatest(
			WorkerLodgingActions.deleteWorkerLodgingsRequest.type,
			deleteWorkerLodgings
		),
		takeLatest(
			WorkerLodgingActions.getProviderInfoListRequest.type,
			getProviderInfoList
		),
		takeLatest(WorkerLodgingActions.createLodgingRequest.type, createLodging),
		takeLatest(
			WorkerLodgingActions.deleteWorkerLodgingByIdRequest.type,
			deleteWorkerLodgingById
		),
		takeLatest(
			WorkerLodgingActions.getApplicantListByLodgingIdRequest.type,
			getApplicantListByLodgingId
		),
		takeLatest(
			WorkerLodgingActions.createLodgingApplicantRequest.type,
			createLodgingApplicant
		),
		takeLatest(
			WorkerLodgingActions.uploadExcelLodgingRequest.type,
			uploadExcelLodgingSaga
		),
		takeLatest(
			WorkerLodgingActions.getWorkerLodgingApplicantListRequest.type,
			getWorkerLodgingApplicantListSaga
		),
		takeLatest(
			WorkerLodgingActions.deleteApplicantListByLodgingIdRequest.type,
			deleteApplicantListByLodgingId
		),
		takeLatest(
			WorkerLodgingActions.updateLodgingProviderRequest.type,
			updateLodgingProviderSaga
		),

		// WORKER RECOMMENDER
		takeLatest(
			WorkerRecommenderActions.getWorkerRecommenderApplicantListRequest.type,
			getWorkerRecommenderApplicantListSaga
		),
		takeLatest(
			WorkerRecommenderActions.getAllWorkerRecommenderApplicantListRequest.type,
			getAllWorkerRecommenderApplicantListSaga
		),
		takeLatest(
			WorkerRecommenderActions.getWorkerRecommenderListRequest.type,
			getWorkerRecommenderListSaga
		),
		takeLatest(
			WorkerRecommenderActions.getWorkerRecommenderExcelListRequest.type,
			getWorkerRecommenderExcelListSaga
		),
		takeLatest(
			WorkerRecommenderActions.getWorkerRecommenderDetailRequest.type,
			getWorkerRecommenderDetail
		),
		takeLatest(
			WorkerRecommenderActions.deleteWorkerRecommendersRequest.type,
			deleteWorkerRecommenders
		),
		takeLatest(
			WorkerRecommenderActions.createWorkerRecommenderRequest.type,
			createWorkerRecommenderSaga
		),
		takeLatest(
			WorkerRecommenderActions.deleteWorkerRecommenderApplicantRequest.type,
			deleteWorkerRecommenderApplicantSaga
		),
		takeLatest(
			WorkerRecommenderActions.createWorkerRecommenderApplicantRequest.type,
			createWorkerRecommenderApplicantSaga
		),
		takeLatest(
			WorkerRecommenderActions.uploadExcelRecommenderRequest.type,
			uploadExcelRecommenderSaga
		),
		takeLatest(
			WorkerRecommenderActions.getWorkerRecommenderLodgingListRequest.type,
			getWorkerRecommenderLodgingListSaga
		),
		takeLatest(
			WorkerRecommenderActions.deleteWorkerRecommenderLodgingRequest.type,
			deleteWorkerRecommenderLodgingSaga
		),

		//US1-01 UNIT SETTING
		takeLatest(
			UnitSettingActions.getUnitSettingRequest.type,
			getUnitSettingMasterInfo
		),
		takeLatest(
			UnitSettingActions.updateUnitSettingRequest.type,
			updateUnitSettingMasterInfo
		),
		takeLatest(
			UnitSettingActions.deleteUnitSettingRequest.type,
			deleteUnitSettingMasterInfo
		),

		// WORKER SALARY
		takeLatest(
			WorkerSalaryActions.getWorkerSalaryListRequest.type,
			getWorkerSalaryListSaga
		),
		takeLatest(
			WorkerSalaryActions.getWorkerSalaryExcelListRequest.type,
			getWorkerSalaryExcelListSaga
		),
		takeLatest(
			WorkerSalaryActions.deleteWorkerSalaryRequest.type,
			deleteWorkerSalary
		),

		takeLatest(
			WorkerSalaryActions.updateWorkerSalaryRequest.type,
			updateWorkerSalary
		),

		//FM1-01 DEFAULT INFO UNIT
		takeLatest(
			Fm1_01DefaultInfoUnitActions.getDefaultInfoUnitDetailRequest.type,
			getDefaultInfoUnitDetail
		),

		// DISTRICT ALLOW IP
		takeLatest(
			DistrictAllowIpActions.getDistrictAllowIpListRequest.type,
			getDistrictAllowIpList
		),
		takeLatest(
			DistrictAllowIpActions.createDistrictAllowIpRequest.type,
			createDistrictAllowIp
		),
		takeLatest(
			DistrictAllowIpActions.deleteDistrictAllowIpRequest.type,
			deleteDistrictAllowIp
		),
		takeLatest(
			DistrictAllowIpActions.updateDistrictAllowIpRequest.type,
			updateDistrictAllowIp
		),

		// WORKER UNAUTHORIZED_DEPARTURE
		takeLatest(
			WorkerUnauthorizedDepartureActions
				.getWorkerUnauthorizedDepartureListRequest.type,
			getWorkerUnauthorizedDepartureListSaga
		),
		takeLatest(
			WorkerUnauthorizedDepartureActions
				.getWorkerUnauthorizedDepartureExcelListRequest.type,
			getWorkerUnauthorizedDepartureExcelListSaga
		),
		takeLatest(
			WorkerUnauthorizedDepartureActions
				.deleteWorkerUnauthorizedDepartureRequest.type,
			deleteWorkerUnauthorizedDeparture
		),
		takeLatest(
			WorkerUnauthorizedDepartureActions
				.createWorkerUnauthorizedDepartureRequest.type,
			createWorkerUnauthorizedDeparture
		),
		takeLatest(
			WorkerUnauthorizedDepartureActions
				.getWorkerUnauthorizedDepartureDetailRequest.type,
			getWorkerUnauthorizedDepartureDetail
		),

		//WORKER DOCUMENT
		takeLatest(
			WorkerDocumentActions.getWorkerDocumentListRequest.type,
			getWorkerDocumentList
		),
		takeLatest(
			WorkerDocumentActions.deleteWorkerDocumentRequest.type,
			deleteWorkerDocument
		),
		takeLatest(
			WorkerDocumentActions.getWorkerDocumentDetailRequest.type,
			getWorkerDocumentDetail
		),
		takeLatest(
			WorkerDocumentActions.updateDocumentRequest.type,
			updateWorkerDocument
		),

		//WORKER PROGRAM
		takeLatest(
			WorkerProgramActions.getWorkerProgramListRequest.type,
			getWorkerProgramListSaga
		),
		takeLatest(
			WorkerProgramActions.getWorkerProgramExcelListRequest.type,
			getWorkerProgramExcelListSaga
		),
		takeLatest(
			WorkerProgramActions.getWorkerProgramAllListRequest.type,
			getWorkerProgramAllList
		),
		takeLatest(
			WorkerProgramActions.deleteWorkerProgramRequest.type,
			deleteWorkerProgram
		),
		takeLatest(
			WorkerProgramActions.createWorkerProgramRequest.type,
			createWorkerPrograms
		),
		takeLatest(
			WorkerProgramActions.getWorkerProgramDetailRequest.type,
			getWorkerProgramDetail
		),

		takeLatest(
			WorkerProgramActions.getWorkerProgramApplicantListRequest.type,
			getWorkerProgramApplicantList
		),
		takeLatest(
			WorkerProgramActions.deleteWorkerProgramApplicantByIdRequest.type,
			deleteWorkerProgramApplicantList
		),
		takeLatest(
			WorkerProgramActions.createWorkerProgramApplicantRequest.type,
			createWorkerProgramApplicant
		),
		takeLatest(
			WorkerProgramActions.getWorkerProgramFranchiseListRequest.type,
			getWorkerProgramFranchiseList
		),
		takeLatest(
			WorkerProgramActions.deleteWorkerProgramFranchiseByIdRequest.type,
			deleteWorkerProgramFranchiseList
		),
		takeLatest(
			WorkerProgramActions.createWorkerProgramFranchiseRequest.type,
			createWorkerProgramFranchises
		),

		takeLatest(
			WorkerProgramActions.getWorkerProgramApplicantStatusRequest.type,
			getWorkerProgramApplicantStatus
		),
		takeLatest(
			WorkerProgramActions.getWorkerProgramFranchiseStatusRequest.type,
			getWorkerProgramFranchiseStatus
		),

		// WORKER PROGRAM STATUS
		takeLatest(
			WorkerProgramStatusActions.getWorkerProgramStatusListRequest.type,
			getWorkerProgramStatusList
		),
		takeLatest(
			WorkerProgramStatusActions.getWorkerProgramStatusExcelListRequest.type,
			getWorkerProgramStatusExcelList
		),
		takeLatest(
			WorkerProgramStatusActions.deleteWorkerProgramStatusRequest.type,
			deleteWorkerProgramStatus
		),

		// WORKER_EXTENSION_STAY
		takeLatest(
			WorkerExtensionStayActions.createWorkerExtensionStayRequest.type,
			createWorkerExtensionStay
		),
		takeLatest(
			WorkerExtensionStayActions.getApplicantByFranchiseExtensionStayListRequest
				.type,
			getApplicantByFranchiseExtensionStay
		),
		takeLatest(
			WorkerExtensionStayActions.getApplicantListByIdsRequest.type,
			getApplicantListByIds
		),
		takeLatest(
			WorkerExtensionStayActions.getWorkerExtensionStayDetailRequest.type,
			getWorkerExtensionStayDetail
		),
		takeLatest(
			WorkerExtensionStayActions.deleteWorkerExtensionStayRequest.type,
			deleteWorkerExtensionStay
		),
		takeLatest(
			WorkerExtensionStayActions.updateFranchiseWorkerExtensionStayRequest.type,
			updateFranchiseWorkerExtensionStay
		),
		takeLatest(
			WorkerExtensionStayActions.getApplicantForExtensionStayListRequest.type,
			getApplicantForExtensionStayList
		),
		takeLatest(
			WorkerExtensionStayActions.deleteApplicantExtensionStayRequest.type,
			deleteApplicantExtensionStay
		),
		takeLatest(
			WorkerExtensionStayActions.createApplicantForExtensionStayRequest.type,
			createApplicantForExtensionStay
		),
		takeLatest(
			WorkerExtensionStayActions.getWorkerExtensionStayListRequest.type,
			getWorkerExtensionStayListSaga
		),
		takeLatest(
			WorkerExtensionStayActions.getWorkerExtensionStayExcelListRequest.type,
			getWorkerExtensionStayExcelListSaga
		),
		takeLatest(
			WorkerExtensionStayActions.deleteExtensionStayRequest.type,
			deleteExtensionStay
		),

		// WORKER CHANGE WORK PLACE
		takeLatest(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceListRequest.type,
			getWorkerChangeWorkPlaceListSaga
		),

		takeLatest(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceExcelListRequest
				.type,
			getWorkerChangeWorkPlaceExcelListSaga
		),

		takeLatest(
			WorkerChangeWorkPlaceActions.deleteWorkerChangeWorkPlaceRequest.type,
			deleteWorkerChangeWorkPlace
		),

		takeLatest(
			WorkerChangeWorkPlaceActions.createWorkerChangeWorkPlaceRequest.type,
			createWorkerChangeWorkPlace
		),

		takeLatest(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceDetailRequest.type,
			getWorkerChangeWorkPlaceDetail
		),
		// DEFINE DOCUMENT UPLOAD
		takeLatest(
			DefineDocumentUploadActions.getDefineDocumentUploadListRequest.type,
			getDefineDocumentUploadListByPage
		),

		takeLatest(
			DefineDocumentUploadActions.updateDocumentRequest.type,
			updateDocumentUpload
		),

		// DASHBOARD
		takeLatest(
			WorkerDashboardActions.getWorkerDashboardStatisticRequest.type,
			getWorkerDashboardStatistic
		),
		takeLatest(
			WorkerDashboardActions.getWorkerDashboardStatisticApplicantRequest.type,
			getWorkerDashboardStatisticApplicant
		),
		takeLatest(
			WorkerDashboardActions.getWorkerDashboardStatisticFranchiseRequest.type,
			getWorkerDashboardStatisticFranchise
		),
		takeLatest(
			WorkerDashboardActions.getWorkerDashboardNoticeListRequest.type,
			getWorkerDashboardNoticeList
		),
		takeLatest(
			WorkerDashboardActions.getWorkerDashboardInquiryListRequest.type,
			getWorkerDashboardInquiryList
		),
		takeLatest(
			WorkerDashboardActions.getWorkerDashboardUseTipListRequest.type,
			getWorkerDashboardUseTipList
		),
		takeLatest(
			WorkerDashboardActions.getWorkerDashboardNoticeReceiveListRequest.type,
			getWorkerDashboardNoticeReceiveList
		),

		// ASSIGNMENT CALENDAR
		takeLatest(
			AssignmentCalendarActions.getPublicListWithDateRequest.type,
			getPublicListWithDateSaga
		),
		takeLatest(
			AssignmentCalendarActions.getEnablePublicApplicantsRequest.type,
			getEnablePublicApplicants
		),
		takeLatest(
			AssignmentCalendarActions.getPublicAssignmentRequest.type,
			getPublicAssignment
		),
		takeLatest(
			AssignmentCalendarActions.getApplicantAssignmentAutocompleteRequest.type,
			getApplicantAssignmentAutocomplete
		),
		takeLatest(
			AssignmentCalendarActions.getFranchiseAssignmentAutocompleteRequest.type,
			getFranchiseAssignmentAutocomplete
		),

		// WORK_HISTORY_LAYER
		takeLatest(
			WorkHistoryLayerActions.getWorkHistoryLayerListRequest.type,
			getWorkHistoryLayerList
		),

		// WORKER ASSIGNMENT
		takeLatest(
			WorkerAssignmentActions.getWorkerAssignmentListRequest.type,
			getWorkerAssignmentListSaga
		),
		takeLatest(
			WorkerAssignmentActions.getWorkerAssignmentExcelListRequest.type,
			getWorkerAssignmentExcelListSaga
		),
		takeLatest(
			WorkerAssignmentActions.getWorkerAssignmentDetailRequest.type,
			getWorkerAssignmentDetail
		),
		takeLatest(
			WorkerAssignmentActions.deleteWorkerAssignmentRequest.type,
			deleteWorkerAssignments
		),
		takeLatest(
			WorkerAssignmentActions.getWorkerAssignmentApplicantListRequest.type,
			getWorkerAssignmentApplicantListSaga
		),
		takeLatest(
			WorkerAssignmentActions.updateWorkerAssignmentApplicantStatusRequest.type,
			updateWorkerAssignmentApplicantStatusSaga
		),
		takeLatest(
			WorkerAssignmentActions.getWorkerAssignmentEvaluationRequest.type,
			getWorkerAssignmentEvaluationSaga
		),
		takeLatest(
			WorkerAssignmentActions.uploadExcelAssignmentRequest.type,
			uploadExcelAssignmentSaga
		),
		takeLatest(
			WorkerAssignmentActions.uploadExcelPublicAssignmentRequest.type,
			uploadExcelPublicAssignmentSaga
		),
		takeLatest(
			WorkerAssignmentFranchiseActions.getWorkerAssignmentFranchiseListRequest
				.type,
			getWorkerAssignmentFranchiseListSaga
		),
		takeLatest(
			WorkerAssignmentFranchiseActions
				.getWorkerAssignmentFranchiseExcelListRequest.type,
			getWorkerAssignmentFranchiseExcelListSaga
		),
		takeLatest(
			WorkerAssignmentFranchiseActions.deleteWorkerAssignmentFranchiseRequest
				.type,
			deleteWorkerAssignmentFranchiseSaga
		),

		takeLatest(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicListRequest.type,
			getWorkerAssignmentPublicListSaga
		),
		takeLatest(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicExcelListRequest
				.type,
			getWorkerAssignmentPublicExcelListSaga
		),
		takeLatest(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicDetailRequest.type,
			getWorkerAssignmentPublicDetailSaga
		),
		takeLatest(
			WorkerAssignmentPublicActions
				.getWorkerAssignmentPublicApplicantListRequest.type,
			getWorkerAssignmentPublicApplicantListSaga
		),
		takeLatest(
			WorkerAssignmentPublicActions.deleteWorkerAssignmentPublicRequest.type,
			deleteWorkerAssignmentPublicSaga
		),

		takeLatest(
			CommonActions.getDocumentJsonContentRequest.type,
			getDocumentJsonContentSaga
		),

		takeLatest(
			MSelectLodgingPopupActions.getMSelectLodgingPopupListRequest.type,
			getMSelectLodgingPopupList
		),

		// FOREIGN USER
		takeLatest(
			ForeignUserActions.getForeignUserListRequest.type,
			getForeignUserList
		),
		takeLatest(
			ForeignUserActions.createForeignUserRequest.type,
			createForeignUsers
		),
		takeLatest(
			ForeignUserActions.getForeignUserDetailRequest.type,
			getForeignUserDetail
		),
		takeLatest(
			ForeignUserActions.deleteForeignUserRequest.type,
			deleteForeignUsers
		),

		// FOREIGN APPLICANT
		takeLatest(
			ForeignApplicantActions.getForeignApplicantListRequest.type,
			getForeignApplicantList
		),
		takeLatest(
			ForeignApplicantActions.createForeignApplicantRequest.type,
			createForeignApplicants
		),
		takeLatest(
			ForeignApplicantActions.getForeignApplicantDetailRequest.type,
			getForeignApplicantDetail
		),
		takeLatest(
			ForeignApplicantActions.deleteForeignApplicantRequest.type,
			deleteForeignApplicants
		),
		takeLatest(
			ForeignApplicantActions.getForeignApplicantProgramListRequest.type,
			getForeignApplicantProgramListSaga
		),
		takeLatest(
			ForeignApplicantActions.resetPasswordRequest.type,
			resetPasswordSaga
		),
		// FOREIGN DASHBOARD
		takeLatest(
			ForeignDashboardActions.getForeignDashboardStatisticRequest.type,
			getForeignDashboardStatistic
		),
		takeLatest(
			ForeignDashboardActions.getContractedKoreanBusinessListRequest.type,
			getContractedKoreanBusiness
		),

		//FOREIGN DEFAULT INFO UNIT
		takeLatest(
			OI1_01DefaultInfoUnitActions.getForeignDefaultInfoUnitDetailRequest.type,
			getForeignDefaultInfoUnitDetail
		),
		takeLatest(
			OI1_01DefaultInfoUnitActions.getForeignDomesticUnitListRequest.type,
			getForeignDomesticUnitList
		),
		// FOREIGN PROGRAM
		takeLatest(
			ForeignProgramActions.getForeignProgramListRequest.type,
			getForeignProgramList
		),
		takeLatest(
			ForeignProgramActions.getForeignProgramDetailRequest.type,
			getForeignProgramDetail
		),
		takeLatest(
			ForeignProgramActions.getForeignProgramApplicantListRequest.type,
			getForeignProgramApplicantList
		),

		// FOOTER INFO
		takeLatest(
			FooterInfoActions.getFooterInfoListRequest.type,
			getFooterInfoList
		),
		takeLatest(
			FooterInfoActions.deleteFooterInfoRequest.type,
			deleteFooterInfo
		),
		takeLatest(
			FooterInfoActions.createFooterInfoRequest.type,
			createFooterInfo
		),

		// CONTRACTED FOREIGN BUSINESS
		takeLatest(
			ContractedForeignBusinessActions.getContractedForeignBusinessListRequest
				.type,
			getContractedForeignBusiness
		),
		takeLatest(
			ContractedForeignBusinessActions.deleteContractedForeignBusinessRequest
				.type,
			deleteContractedForeignBusiness
		),
		takeLatest(
			ContractedForeignBusinessActions.addContractedForeignBusinessRequest.type,
			addContractedForeignBusiness
		),

		// FOREIGN SYSTEM UNIT
		takeLatest(
			ForeignSystemUnitActions.getSystemUnitListRequest.type,
			getForeignSystemUnitList
		),
		takeLatest(
			ForeignSystemUnitActions.createSystemUnitRequest.type,
			createForeignSystemUnit
		),
		takeLatest(
			ForeignSystemUnitActions.deleteSystemUnitRequest.type,
			deleteForeignSystemUnit
		),
		takeLatest(
			ForeignSystemUnitActions.getSystemUnitDetailRequest.type,
			getForeignSystemUnitDetail
		),
		takeLatest(
			ForeignSystemUnitActions.getContractedKoreanBusinessListRequest.type,
			getContractedKoreanBusinessSystem
		),

		// WORKER SERVICE TIP
		takeLatest(
			WorkerUseTipActions.getWorkerUseTipListRequest.type,
			getWorkerUseTipList
		),
		takeLatest(
			WorkerUseTipActions.getWorkerUseTipDetailRequest.type,
			getWorkerUseTipDetail
		),
		// SYSTEM USE TIP
		takeLatest(
			SystemUseTipActions.getSystemUseTipListRequest.type,
			getSystemUseTipList
		),
		takeLatest(
			SystemUseTipActions.getSystemUseTipDetailRequest.type,
			getSystemUseTipDetail
		),
		takeLatest(
			SystemUseTipActions.createSystemUseTipRequest.type,
			createSystemUseTip
		),
		takeLatest(
			SystemUseTipActions.deleteSystemUseTipRequest.type,
			deleteSystemUseTip
		),
		// WORKER HISTORY
		takeLatest(
			WorkerHistoryActions.getWorkerHistoryListRequest.type,
			getWorkerHistoryList
		),

		// WORKER PUBLIC SALARY
		takeLatest(
			WorkerPublicSalaryActions.getPublicSalaryListRequest.type,
			getPublicSalaryListSaga
		),
		takeLatest(
			WorkerPublicSalaryActions.getPublicSalaryExcelListRequest.type,
			getPublicSalaryExcelListSaga
		),
		takeLatest(
			WorkerPublicSalaryActions.getPublicSalaryDetailRequest.type,
			getPublicSalaryDetailSaga
		),
		takeLatest(
			WorkerPublicSalaryActions.getPublicSalaryApplicantListRequest.type,
			getPublicSalaryApplicantListSaga
		),

		// PUBLIC WORK HISTORY LAYER
		takeLatest(
			PublicWorkHistoryLayerActions.getPublicWorkHistoryLayerListRequest.type,
			getPublicWorkHistoryLayerList
		),

		// WORKER AUDIT MONITORING
		takeLatest(
			WorkerAuditMonitoringActions.getWorkerAuditMonitoringListRequest.type,
			getWorkerAuditMonitoringListSaga
		),

		// DEVICE MOBILE
		takeLatest(
			DeviceMobileActions.getDeviceMobileListRequest.type,
			getDeviceMobileListSaga
		),
		takeLatest(
			DeviceMobileActions.getDeviceMobileDetailRequest.type,
			getDeviceMobileDetailSaga
		),
		takeLatest(
			DeviceMobileActions.approveMobileDeviceRequest.type,
			approveMobileDeviceSaga
		),
		takeLatest(
			DeviceMobileActions.rejectMobileDeviceRequest.type,
			rejectMobileDeviceSaga
		),
		takeLatest(
			DeviceMobileActions.revokeMobileDeviceRequest.type,
			revokeMobileDeviceSaga
		),
		takeLatest(
			DeviceMobileActions.reapproveMobileDeviceRequest.type,
			reapproveMobileDeviceSaga
		),

		// DEVICE TABLET
		takeLatest(
			DeviceTabletActions.getDeviceTabletListRequest.type,
			getDeviceTabletListSaga
		),
		takeLatest(
			DeviceTabletActions.verifyTabletRegisterCodeRequest.type,
			verifyTabletRegisterCodeSaga
		),
		takeLatest(
			DeviceTabletActions.verifyTabletRemoteCodeRequest.type,
			verifyTabletRemoteCodeSaga
		),

		// DEVICE LOG
		takeLatest(
			DeviceLogActions.getDeviceLogListRequest.type,
			getDeviceLogListSaga
		),
	]);
}
